import { VISI_MISI } from "../data/content";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";

export const VisionMission = () => (
    <section
        data-testid="visi-misi-section"
        aria-labelledby="visi-misi-title"
        className="bg-bh-light py-24 sm:py-32"
    >
        <div className="max-w-[1565px] mx-auto">
            <SectionHeader
                eyebrow={VISI_MISI.eyebrow}
                title={VISI_MISI.title}
                testid="visi-misi-title"
            />
            <div className="px-6 sm:px-8 grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
                <Reveal>
                    <article
                        data-testid="visi-card"
                        className="h-full bg-bh-deep rounded-3xl p-9 sm:p-12 relative overflow-hidden"
                    >
                        <div aria-hidden="true" className="absolute inset-0 pattern-star-gold opacity-[0.06]" />
                        <div className="relative">
                            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-bh-softgold mb-6">
                                Visi
                            </p>
                            <p
                                data-testid="visi-text"
                                className="font-serif text-xl sm:text-2xl leading-relaxed text-white"
                            >
                                {VISI_MISI.visi}
                            </p>
                        </div>
                    </article>
                </Reveal>
                <Reveal delay={0.14}>
                    <article
                        data-testid="misi-card"
                        className="h-full bg-white rounded-3xl border border-bh-green/12 p-9 sm:p-12 shadow-[0_14px_40px_rgba(16,134,108,0.07)]"
                    >
                        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-bh-gold mb-6">
                            Misi
                        </p>
                        <p data-testid="misi-intro" className="text-base leading-relaxed text-bh-ink/90 mb-7">
                            {VISI_MISI.misiIntro}
                        </p>
                        <ol data-testid="misi-list" className="space-y-4 mb-7">
                            {VISI_MISI.misiPoints.map((point, i) => (
                                <li key={point.text} className="flex items-center gap-4">
                                    <span className="flex items-center justify-center w-11 h-11 rounded-full bg-bh-light border border-bh-green/15 shrink-0">
                                        <point.icon className="w-5 h-5 text-bh-green" aria-hidden="true" />
                                    </span>
                                    <span className="text-base font-semibold text-bh-deep">
                                        <span className="text-bh-gold mr-2 font-serif">{i + 1}.</span>
                                        {point.text}
                                    </span>
                                </li>
                            ))}
                        </ol>
                        <p data-testid="misi-outro" className="text-base leading-relaxed text-bh-ink/90">
                            {VISI_MISI.misiOutro}
                        </p>
                    </article>
                </Reveal>
            </div>
        </div>
    </section>
);
